import { useQuery, useMutation, useQueryClient } from "react-query";
import adminApi from "../api/adminApi";

export const usePublicDonorsList = (params) => {
  return useQuery(
    ["admin-public-donors", params],
    () => adminApi.listPublicDonors(params),
    { keepPreviousData: true }
  );
};

export const usePublicDonor = (id) => {
  return useQuery(
    ["admin-public-donor", id],
    () => adminApi.getPublicDonor(id),
    { enabled: !!id }
  );
};

export const useUpdatePublicDonor = () => {
  const qc = useQueryClient();
  return useMutation(
    ({ id, data }) => adminApi.updatePublicDonor(id, data),
    {
      onSuccess: () => {
        qc.invalidateQueries("admin-public-donors");
      },
    }
  );
};

export const useDeletePublicDonor = () => {
  const qc = useQueryClient();
  return useMutation((id) => adminApi.deletePublicDonor(id), {
    onSuccess: () => {
      qc.invalidateQueries("admin-public-donors");
    },
  });
};
